import LegalDetail from '@modules/legal/components/LegalDetail/LegalDetail'
import { dehydrate, QueryClient, useQuery } from 'react-query'
import { getLegalDocs } from 'src/@shared/service/cms-api'
import { LegalDoc } from 'src/@shared/types/cms/legalDoc'

import { useFadeInAnimation } from '@atk/hooks/useFadeInAnimation'

import CustomHead, { OpenGraphProps } from '../../@shared/components/head/customHead/customHead'
import { CMSList } from '../../@shared/types/cms/cms-list'

export type BlogDetailSSProps = {
    query: { slug: string }
}

const initialArgs = { sort: 'position', limit: 0, page: 1 }

export async function getServerSideProps({ query }: BlogDetailSSProps) {
    const queryClient = new QueryClient()
    // prefetch data on the server
    await queryClient.fetchQuery(['legaldocs'], () => getLegalDocs(initialArgs))
    return {
        props: {
            // dehydrate query cache
            dehydratedState: dehydrate(queryClient),
            slug: query.slug,
        },
    }
}

export default function Legal({ slug }: { slug: string }) {
    const { data } = useQuery(['legaldocs'], () => getLegalDocs(initialArgs))
    const legalDocs = (data as CMSList<LegalDoc>)?.data

    const doc = legalDocs.find((x: LegalDoc) => x.meta.slug === slug)

    const title = doc ? doc.meta.title : ''
    const description = doc ? doc.meta.description ?? '' : ''
    const og: OpenGraphProps = {
        ogTitle: title,
        ogDescription: description,
    }
    const { showFadeIn, showBackground } = useFadeInAnimation(1000)
    const pageClass = `legalPage ${showBackground ? 'd-block' : 'd-none'} ${showFadeIn ? 'fadeIn' : ''}`
    return (
        <div className={pageClass}>
            <CustomHead title={title} description={description} og={og} />
            <main>{doc && <LegalDetail doc={doc} />}</main>
        </div>
    )
}
